import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { useAdminData } from '../contexts/AdminDataContext';
import { Bell, Globe, Shield, Database, Mail, Save, RefreshCw } from 'lucide-react';
const Settings = () => {
  const {
    showToast
  } = useAdminData();
  // Notification Settings
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [weeklyReports, setWeeklyReports] = useState(true);
  // Platform Settings
  const [language, setLanguage] = useState('it');
  const [timezone, setTimezone] = useState('Europe/Rome');
  const [dateFormat, setDateFormat] = useState('DD/MM/YYYY');
  // Security Settings
  const [twoFactorAuth, setTwoFactorAuth] = useState(false);
  const [sessionTimeout, setSessionTimeout] = useState('30');
  // Data Settings
  const [dataRetention, setDataRetention] = useState('12');
  const [autoBackup, setAutoBackup] = useState(true);
  const handleSaveSettings = () => {
    showToast('Impostazioni salvate con successo');
  };
  const handleResetSettings = () => {
    setEmailNotifications(true);
    setPushNotifications(true);
    setWeeklyReports(true);
    setLanguage('it');
    setTimezone('Europe/Rome');
    setDateFormat('DD/MM/YYYY');
    setTwoFactorAuth(false);
    setSessionTimeout('30');
    setDataRetention('12');
    setAutoBackup(true);
    showToast('Impostazioni ripristinate ai valori predefiniti');
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-4099">
      <div className="w-20 flex-shrink-0" data-id="element-4100">
        <Sidebar data-id="element-4101" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-4102">
        <Topbar data-id="element-4103" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-4104">
          {/* Page Header */}
          <div className="mb-8" data-id="element-4105">
            <h1 className="text-2xl font-semibold text-gray-900" data-id="element-4106">
              Impostazioni
            </h1>
            <p className="text-sm font-normal text-gray-500 mt-1" data-id="element-4107">
              Configura le preferenze della piattaforma Greenback
            </p>
          </div>

          {/* Settings Grid */}
          <div className="grid grid-cols-1 gap-6 max-w-4xl" data-id="element-4108">
            {/* Notifications Settings */}
            <div className="rounded-sm border border-gray-200 bg-white p-6" data-id="element-4109">
              <div className="flex items-center gap-3 mb-4" data-id="element-4110">
                <Bell className="h-5 w-5 text-gray-400" data-id="element-4111" />
                <div data-id="element-4112">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-4113">
                    Notifiche
                  </h3>
                  <p className="text-sm font-normal text-gray-500" data-id="element-4114">
                    Gestisci le tue preferenze di notifica
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-4115">
                <div className="flex items-center justify-between" data-id="element-4116">
                  <div data-id="element-4117">
                    <p className="text-sm font-medium text-gray-900" data-id="element-4118">
                      Notifiche Email
                    </p>
                    <p className="text-xs font-normal text-gray-500" data-id="element-4119">
                      Ricevi aggiornamenti via email
                    </p>
                  </div>
                  <button onClick={() => setEmailNotifications(!emailNotifications)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${emailNotifications ? 'bg-greenback' : 'bg-gray-200'}`} data-id="element-4120">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${emailNotifications ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-4121" />
                  </button>
                </div>

                <div className="flex items-center justify-between" data-id="element-4122">
                  <div data-id="element-4123">
                    <p className="text-sm font-medium text-gray-900" data-id="element-4124">
                      Notifiche Push
                    </p>
                    <p className="text-xs font-normal text-gray-500" data-id="element-4125">
                      Ricevi notifiche in tempo reale
                    </p>
                  </div>
                  <button onClick={() => setPushNotifications(!pushNotifications)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${pushNotifications ? 'bg-greenback' : 'bg-gray-200'}`} data-id="element-4126">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${pushNotifications ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-4127" />
                  </button>
                </div>

                <div className="flex items-center justify-between" data-id="element-4128">
                  <div data-id="element-4129">
                    <p className="text-sm font-medium text-gray-900" data-id="element-4130">
                      Report Settimanali
                    </p>
                    <p className="text-xs font-normal text-gray-500" data-id="element-4131">
                      Ricevi un riepilogo settimanale
                    </p>
                  </div>
                  <button onClick={() => setWeeklyReports(!weeklyReports)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${weeklyReports ? 'bg-greenback' : 'bg-gray-200'}`} data-id="element-4132">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${weeklyReports ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-4133" />
                  </button>
                </div>
              </div>
            </div>

            {/* Platform Settings */}
            <div className="rounded-sm border border-gray-200 bg-white p-6" data-id="element-4134">
              <div className="flex items-center gap-3 mb-4" data-id="element-4135">
                <Globe className="h-5 w-5 text-gray-400" data-id="element-4136" />
                <div data-id="element-4137">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-4138">
                    Piattaforma
                  </h3>
                  <p className="text-sm font-normal text-gray-500" data-id="element-4139">
                    Preferenze regionali e formato
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-4140">
                <div data-id="element-4141">
                  <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-4142">
                    Lingua
                  </label>
                  <select value={language} onChange={e => setLanguage(e.target.value)} className="w-full rounded-sm border border-gray-300 px-3 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback" data-id="element-4143">
                    <option value="it" data-id="element-4144">Italiano</option>
                    <option value="en" data-id="element-4145">English</option>
                    <option value="es" data-id="element-4146">Español</option>
                    <option value="fr" data-id="element-4147">Français</option>
                  </select>
                </div>

                <div data-id="element-4148">
                  <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-4149">
                    Fuso Orario
                  </label>
                  <select value={timezone} onChange={e => setTimezone(e.target.value)} className="w-full rounded-sm border border-gray-300 px-3 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback" data-id="element-4150">
                    <option value="Europe/Rome" data-id="element-4151">Europe/Rome (GMT+1)</option>
                    <option value="Europe/London" data-id="element-4152">Europe/London (GMT+0)</option>
                    <option value="America/New_York" data-id="element-4153">
                      America/New York (GMT-5)
                    </option>
                    <option value="Asia/Tokyo" data-id="element-4154">Asia/Tokyo (GMT+9)</option>
                  </select>
                </div>

                <div data-id="element-4155">
                  <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-4156">
                    Formato Data
                  </label>
                  <select value={dateFormat} onChange={e => setDateFormat(e.target.value)} className="w-full rounded-sm border border-gray-300 px-3 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback" data-id="element-4157">
                    <option value="DD/MM/YYYY" data-id="element-4158">DD/MM/YYYY</option>
                    <option value="MM/DD/YYYY" data-id="element-4159">MM/DD/YYYY</option>
                    <option value="YYYY-MM-DD" data-id="element-4160">YYYY-MM-DD</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Security Settings */}
            <div className="rounded-sm border border-gray-200 bg-white p-6" data-id="element-4161">
              <div className="flex items-center gap-3 mb-4" data-id="element-4162">
                <Shield className="h-5 w-5 text-gray-400" data-id="element-4163" />
                <div data-id="element-4164">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-4165">
                    Sicurezza
                  </h3>
                  <p className="text-sm font-normal text-gray-500" data-id="element-4166">
                    Proteggi il tuo account
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-4167">
                <div className="flex items-center justify-between" data-id="element-4168">
                  <div data-id="element-4169">
                    <p className="text-sm font-medium text-gray-900" data-id="element-4170">
                      Autenticazione a Due Fattori
                    </p>
                    <p className="text-xs font-normal text-gray-500" data-id="element-4171">
                      Aggiungi un livello extra di sicurezza
                    </p>
                  </div>
                  <button onClick={() => setTwoFactorAuth(!twoFactorAuth)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${twoFactorAuth ? 'bg-greenback' : 'bg-gray-200'}`} data-id="element-4172">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${twoFactorAuth ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-4173" />
                  </button>
                </div>

                <div data-id="element-4174">
                  <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-4175">
                    Timeout Sessione (minuti)
                  </label>
                  <select value={sessionTimeout} onChange={e => setSessionTimeout(e.target.value)} className="w-full rounded-sm border border-gray-300 px-3 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback" data-id="element-4176">
                    <option value="15" data-id="element-4177">15 minuti</option>
                    <option value="30" data-id="element-4178">30 minuti</option>
                    <option value="60" data-id="element-4179">1 ora</option>
                    <option value="120" data-id="element-4180">2 ore</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Data Settings */}
            <div className="rounded-sm border border-gray-200 bg-white p-6" data-id="element-4181">
              <div className="flex items-center gap-3 mb-4" data-id="element-4182">
                <Database className="h-5 w-5 text-gray-400" data-id="element-4183" />
                <div data-id="element-4184">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-4185">Dati</h3>
                  <p className="text-sm font-normal text-gray-500" data-id="element-4186">
                    Gestione e backup dei dati
                  </p>
                </div>
              </div>

              <div className="space-y-4" data-id="element-4187">
                <div data-id="element-4188">
                  <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-4189">
                    Conservazione Dati (mesi)
                  </label>
                  <select value={dataRetention} onChange={e => setDataRetention(e.target.value)} className="w-full rounded-sm border border-gray-300 px-3 py-2 text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback" data-id="element-4190">
                    <option value="6" data-id="element-4191">6 mesi</option>
                    <option value="12" data-id="element-4192">12 mesi</option>
                    <option value="24" data-id="element-4193">24 mesi</option>
                    <option value="36" data-id="element-4194">36 mesi</option>
                  </select>
                </div>

                <div className="flex items-center justify-between" data-id="element-4195">
                  <div data-id="element-4196">
                    <p className="text-sm font-medium text-gray-900" data-id="element-4197">
                      Backup Automatico
                    </p>
                    <p className="text-xs font-normal text-gray-500" data-id="element-4198">
                      Backup giornaliero dei dati
                    </p>
                  </div>
                  <button onClick={() => setAutoBackup(!autoBackup)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${autoBackup ? 'bg-greenback' : 'bg-gray-200'}`} data-id="element-4199">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${autoBackup ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-4200" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="mt-8 flex items-center gap-3 max-w-4xl" data-id="element-4201">
            <button onClick={handleSaveSettings} className="inline-flex items-center px-4 py-2 bg-greenback text-white text-sm font-medium hover:bg-greenback/90 transition-colors" style={{
            borderRadius: '100px'
          }} data-id="element-4202">
              <Save className="h-4 w-4 mr-2" data-id="element-4203" />
              Salva Modifiche
            </button>
            <button onClick={handleResetSettings} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors" style={{
            borderRadius: '100px'
          }} data-id="element-4204">
              <RefreshCw className="h-4 w-4 mr-2" data-id="element-4205" />
              Ripristina Predefiniti
            </button>
          </div>
        </main>
      </div>
    </div>;
};
export default Settings;